import { composeIO } from 'react-compose-io'
import { tabGrupoRegraIO } from './TabGrupoRegra.IO'
import TabGrupoRegraView from './TabGrupoRegra.View'

export const TabGrupoRegra = composeIO(TabGrupoRegraView, tabGrupoRegraIO)
